// extracted by mini-css-extract-plugin
export var cardHeader = "_gx-1";
export var contentCard = "_gx-0";
export var headerActions = "_gx-3";
export var reorderHandle = "_gx-5";
export var titleArea = "_gx-2";
export var titleAreaWithHandle = "_gx-4";